<template>
  <b-row class="px-lg-2 px-4">
    <b-col cols="12" class="mb-4">
      <b-modal
        v-model="open"
        title="Detalhes do Serviço"
        size="lg"
        header-bg-variant="orange"
        header-text-variant="light"
        centered
        hide-footer
        no-close-on-backdrop
      >
      <b-card class="mt-2">
        <b-row>
          <b-col cols="12">
              <div class="bg-warning py-1">
                <h5 class="text-center text-light">Serviço</h5>
              </div>
          </b-col>
          <b-col cols="12" md="12" class="mt-3">
            <strong class="fs-20">Nome</strong>
            <div>
              <span class="fs-20 ml-1">{{ service.name }}</span>
            </div>
          </b-col>
          <b-col cols="12" md="3" class="mt-2">
            <strong class="fs-20">Preço: </strong>
            <div>
              <span class="fs-20">{{ service.price }}</span>
            </div>
          </b-col>
          <b-col cols="12" md="3" class="mt-2">
            <strong class="fs-20">Garantia: </strong>
            <div class="fs-20">
              <span class="mr-1" >{{ service.service_guarantee }}</span>
              <span v-if="service.service_guarantee >1"> meses</span>
              <span v-else>mês</span>
            </div>
          </b-col>
          <b-col cols="12" md="3" class="mt-2">
            <strong class="fs-20">Prazo de instalação: </strong>
            <div class="fs-20">
              <span class="mr-1">{{ service.deadline }}</span>
              <span v-if="service.deadline >1"> horas</span>
              <span v-else>hora</span>
            </div>
          </b-col>
          <b-col cols="12" md="3" class="mt-2">
            <strong class="fs-20">Tipo de Serviço: </strong>
            <div>
              <span class="fs-20">{{ service.type == 1 ? "Instalação" : "" }}</span>
            </div>
          </b-col>
          <b-col cols="12" class="mt-2">
            <strong class="fs-20">Serviços Inclusos: </strong>
            <div>
              <span class="fs-20">{{ service.services_included }}</span>
            </div>
          </b-col>
          <b-col cols="12" class="mt-2">
            <strong class="fs-20">Serviços não Inclusos: </strong>
            <div>
              <span class="fs-20">{{ service.services_not_included }}</span>
            </div>
          </b-col>
          <b-col cols="12" class="mt-2">
            <strong class="fs-20">Preparação para Instalação: </strong>
            <div>
              <span class="fs-20">{{ service.prepare_installation }}</span>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="mt-2">
        <b-row>
          <b-col cols="12">
            <div class="bg-warning py-1">
              <h5 class="text-center text-light">Produto(s)</h5>
            </div>
          </b-col>
          <b-col cols="12">
            <b-table
              striped
              responsive
              hover
              show-empty
              :fields="table.headers"
              :items="table.records"
              :busy="loading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle mr-2"></b-spinner>
                  <strong>Carregando...</strong>
                </div>
              </template>

              <template #empty>
                 <h5 class="text-center mt-3">Sem produtos vinculado</h5>
              </template>

              <template #cell(produto_fotos)="data">
                <img 
                  :src="linkFotos(data.item.produto_fotos[0].origem) + data.item.produto_fotos[0].foto_png" 
                  :alt="data.item.produto" 
                  style="width: 50px;"
                />
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card>
      <b-row>
        <b-col cols="12" md="6" class="mt-4">
          <b-button
            variant="danger"
            block
            @click="open=false"
          >
          Fechar
          </b-button>
        </b-col>
      </b-row>
        
    </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from 'Mixins/makeToast';
import { mapActions } from 'vuex';

export default {
  mixins: [makeToast],

  data() {
    return {
      loading: false,
      open: false,
      service: [],
      table: {
        headers: [
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'produto_fotos',
            label: 'Foto ',
            sortable: false,
          },
          {
            key: 'produto',
            label: 'Produto',
            sortable: false,
          },
          {
            key: 'marca',
            label: 'Marca',
            sortable: false,
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
            sortable: false,
          },
        ],
        records: [],
      }
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  methods: {
    ...mapActions('shopkeeper', [
      'getServiceProduct'
    ]),
    toggleOpen(item) {
      this.open = !this.open;
      this.service = item.data;
      this.table.records = [];
      this.get();
    },
    get() {
      const data = {
        idService: this.service.id,
        idShopkeeper: this.dadosUsuario.id
      }
      this.$store.dispatch('startLoader');
        this.getServiceProduct(data)
          .then((resp) => {
            const data = resp.data.data[0].data_product_service;
            data.forEach(element => {
              this.table.records.push(element.product_service[0].data_product[0]);
            });
          })
          .catch(() => {
            this.makeToast(
              'Erro',
              'Houve um erro ao atualizar o serviço!',
              'danger'
            );
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
    },
    linkFotos(origem) {
        if(origem == 'Belenus' || origem == 'fixadores') {
          return 'https://storage.googleapis.com/fotos-prd/';
        } else {
          return process.env.VUE_APP_FOTOS_URL;
        }
      },
  }
}
</script>
